import axios from 'axios';
import Config from './config';

const http = axios.create({})

http.interceptors.request.use(config => {

  config.baseURL = Config.getHost()

  return config
})

export default http